/**
 * Asynchronously loads the component for MyautoiqCampaignsPage
 */

import { lazyLoad } from 'utils/loadable';

export const MyautoiqCampaignsPage = lazyLoad(
  () => import('./index'),
  module => module.MyautoiqCampaignsPage,
);
